import React from 'react';
import { MapPin, Award, Shield, Clock, FileText, Activity } from 'lucide-react';
import mockData from '../mock';

const iconMap = {
  MapPin: MapPin,
  Award: Award,
  Shield: Shield,
  Clock: Clock,
  FileText: FileText,
  Activity: Activity
};

const WhyUsSection = () => {
  const { whyUs } = mockData;

  return (
    <section id="why-us" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-orange-500">Bijaya Solar</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Odisha's trusted solar partner with 500+ successful installations
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyUs.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg card-hover border-l-4 border-orange-500"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;